<template>
  <el-radio
    v-model="session.printType"
    :label="option.id"
    :class="getOptionClass(option)"
    :style="selectedStyle(session.printType, option.id)"
    @click.native="$emit('click-option', option.id)"
  >
    <span class="el-radio__label">{{ getOptionLabel(option) }}</span>
    <EprintCashlessTag v-if="isCashlessSupported(option)" />
    <span class="flex eprint_flex">
      <span class="eprint_left">
        <span class="price_tag">{{ option.size }}</span>
        <span class="price_tag">{{ option.count }}</span>
      </span>
      <span class="eprint_right price"
        >{{ session.eprintPrice
        }}<span class="price-small">円(税込)／{{ option.count }}</span></span
      >
    </span>
    <span v-if="!session.isPrePayment" class="price-memo_seven">{{
      getSevenElevenPriceMemo(session.printFlag)
    }}</span>
  </el-radio>
</template>

<script setup lang="ts">
import EprintCashlessTag from '@/components/format-edit/eprint/EprintCashlessTag.vue'
import { useEprintSession } from '@/composables/format-edit/useEprintSession'
import {
  getOptionClass,
  getOptionLabel,
  getSevenElevenPriceMemo,
  isCashlessSupported,
  selectedStyle,
  type EprintPrintOption
} from '@/utils/format-edit/eprintOptions'

defineProps<{
  option: EprintPrintOption
}>()

defineEmits(['click-option'])

const session = useEprintSession()
</script>
